import React, { ChangeEvent, FC } from 'react'
import { ALLERGENS } from 'constants/allergens'
import { HorizontalLine, Spacer } from 'components/Utility'
import { FormLabel } from 'components/Label'
import { SubDescription } from 'components/Typography'
import { Card, CardInner } from 'components/Card'
import { Checkbox, RadioButton } from 'components/Form'
import { FlexRow } from 'components/Flex'

type Props = {
  allergens: string[]
  handleAllergens: (event: ChangeEvent<HTMLInputElement>) => void
  handleSetAllergens: (event: ChangeEvent<HTMLInputElement>) => void
  isSetAllergens: boolean
}

const ProductEditAllergensSection: FC<Props> = (props) => {
  const { allergens, handleAllergens, handleSetAllergens, isSetAllergens } = props
  return (
    <>
      <FormLabel label={'アレルギー情報'} required={true} />
      <Spacer size={8} />
      <SubDescription
        description={
          '以下の原材料を使用している場合、チェックを入れてください。特定原材料以外で使用している原材料がある場合は、商品説明に記載してください。'
        }
      />
      <Spacer size={8} />
      <Card isOutlined={true}>
        <CardInner>
          <RadioButton
            isChecked={isSetAllergens}
            label={'アレルギー情報あり'}
            onChange={handleSetAllergens}
            value={'set'}
          />
        </CardInner>
        <HorizontalLine color={'grey03'} verticalMargin={16} />
        <CardInner>
          <FlexRow itemNum={'three'} justifyContent={'between'} wrap={'wrap'}>
            {ALLERGENS.slice(0, 3).map((ALLERGEN) => (
              <Checkbox
                key={ALLERGEN.value}
                id={ALLERGEN.value}
                isChecked={allergens.includes(ALLERGEN.value)}
                label={ALLERGEN.label}
                onChange={handleAllergens}
                size={'large'}
              />
            ))}
          </FlexRow>
          <Spacer size={16} />
          <FlexRow itemNum={'three'} justifyContent={'between'} wrap={'wrap'}>
            {ALLERGENS.slice(3, 6).map((ALLERGEN) => (
              <Checkbox
                key={ALLERGEN.value}
                id={ALLERGEN.value}
                isChecked={allergens.includes(ALLERGEN.value)}
                label={ALLERGEN.label}
                onChange={handleAllergens}
                size={'large'}
              />
            ))}
          </FlexRow>
          <Spacer size={16} />
          <FlexRow itemNum={'three'} justifyContent={'between'} wrap={'wrap'}>
            {ALLERGENS.slice(6, 9).map((ALLERGEN) => (
              <Checkbox
                key={ALLERGEN.value}
                id={ALLERGEN.value}
                isChecked={allergens.includes(ALLERGEN.value)}
                label={ALLERGEN.label}
                onChange={handleAllergens}
                size={'large'}
              />
            ))}
          </FlexRow>
        </CardInner>
      </Card>
      <Spacer size={8} />
      <Card isOutlined={true}>
        <CardInner>
          <RadioButton
            isChecked={!isSetAllergens}
            label={'アレルギー情報なし'}
            onChange={handleSetAllergens}
            value={'not_set'}
          />
        </CardInner>
      </Card>
    </>
  )
}

export default ProductEditAllergensSection
